/*
 * CUSTOM: custom-mobile-nav-service.js — 2026-10-12 (agg. 2026-10-15: fix cambio lingua)
 * Blocco "Servizio" nel menu laterale nativo (snippets/custom-mobile-nav-service.liquid):
 * apre/chiude gli elenchi Paese e Lingua. Quando un elenco è aperto, il contenitore del
 * menu riceve la classe .cms-open e l'elenco prende il posto di voci di menu e blocco Servizio.
 * Event delegation: funziona anche se il menu viene creato da Alpine dopo il caricamento.
 */
(() => {
  if (window.__cmsInit) return;
  window.__cmsInit = true;

  let lastTrigger = null;

  const container = (el) => el.closest('.x-container-mobile-nav') || el.closest('[data-cms]').parentElement;

  const openPanel = (trigger) => {
    const root = trigger.closest('[data-cms]');
    const panel = root && root.querySelector(`[data-cms-panel="${trigger.dataset.cmsOpen}"]`);
    if (!panel) return;
    root.querySelectorAll('[data-cms-panel]').forEach((p) => { p.hidden = p !== panel; });
    lastTrigger = trigger;
    container(root).classList.add('cms-open');
    panel.hidden = false;
    const body = panel.querySelector('.cms-panel__body');
    if (body) body.scrollTop = 0;
    const current = panel.querySelector('[aria-current="true"]');
    const back = panel.querySelector('[data-cms-close]');
    (current || back)?.focus({ preventScroll: true });
    if (current) current.scrollIntoView({ block: 'center' });
  };

  const closePanel = (panel, restoreFocus = true) => {
    if (!panel || panel.hidden) return false;
    panel.hidden = true;
    const root = panel.closest('[data-cms]');
    if (root) container(root).classList.remove('cms-open');
    if (restoreFocus && lastTrigger && lastTrigger.isConnected) lastTrigger.focus({ preventScroll: true });
    return true;
  };

  const closeAll = () => {
    document.querySelectorAll('[data-cms-panel]:not([hidden])').forEach((p) => closePanel(p, false));
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const opener = target.closest('[data-cms-open]');
    if (opener) {
      event.preventDefault();
      openPanel(opener);
      return;
    }

    const closer = target.closest('[data-cms-close]');
    if (closer) {
      event.preventDefault();
      closePanel(closer.closest('[data-cms-panel]'));
      return;
    }

    // Scelta paese/lingua: stesso metodo dei selettori della Barra Annunci.
    // form.submit() non genera l'evento "submit", quindi app e script che lo intercettano
    // (es. Langify) non possono bloccare il cambio.
    const option = target.closest('[data-cms-value]');
    if (option) {
      event.preventDefault();
      if (option.getAttribute('aria-current') === 'true') {
        closePanel(option.closest('[data-cms-panel]'));
        return;
      }
      const form = option.closest('form');
      const panel = option.closest('[data-cms-panel]');
      if (!form || !panel) return;
      // Pannello paesi → country_code; pannello lingue → locale_code. Stessi campi e stesso
      // invio (form.submit()) dei selettori della Barra Annunci. return_to: quello di Shopify.
      const name = panel.dataset.cmsPanel === 'language' ? 'locale_code' : 'country_code';
      const field = form.querySelector(`input[name="${name}"]`);
      if (!field) return;
      field.value = option.dataset.cmsValue;
      option.setAttribute('aria-busy', 'true');
      form.submit();
      return;
    }

    // Chiusura del menu nativo (X o sfondo scuro): alla riapertura si riparte dal menu
    if (target.closest('.x-block-mobile-nav-close') || target.matches('.fixed.bg-black')) closeAll();
  });

  // Esc chiude prima l'elenco aperto; un secondo Esc lascia al tema la chiusura del menu
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('[data-cms-panel]:not([hidden])');
    if (open && closePanel(open)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
})();

/*
 * CUSTOM 2026-10-16: colore delle zone del browser attorno alla pagina (smartphone/tablet).
 * Metà superiore della pagina → classe assente (colore Barra Annunci);
 * metà inferiore → html.cmh-edge-bottom (colore footer). Vedi custom-mobile-header.css.
 * Con un pannello aperto (menu, carrello) Safari usa i colori del pannello stesso (elementi fissi).
 * Aggiorna anche <meta name="theme-color"> (iOS ≤ 18, Chrome Android).
 * Listener passivo + requestAnimationFrame: nessun lavoro durante lo scroll oltre a un confronto.
 */
(() => {
  if (window.__cmhEdgeInit) return;
  window.__cmhEdgeInit = true;

  const mq = window.matchMedia('(max-width: 1023px)');
  const root = document.documentElement;
  let ticking = false;
  let meta = null;
  let colors = null;

  const readColors = () => {
    const cs = getComputedStyle(root);
    const top = cs.getPropertyValue('--cab-bg').trim() || '#bde0c9';
    const footer = cs.getPropertyValue('--background-color-footer').trim();
    return { top, bottom: footer ? `rgb(${footer})` : '#432724' };
  };

  const update = () => {
    ticking = false;
    if (!mq.matches) {
      root.classList.remove('cmh-edge-bottom');
      return;
    }
    const range = root.scrollHeight - window.innerHeight;
    const bottom = range > 0 && window.scrollY > range / 2;
    if (root.classList.contains('cmh-edge-bottom') === bottom && meta) return;
    root.classList.toggle('cmh-edge-bottom', bottom);
    meta = meta || document.querySelector('meta[name="theme-color"]');
    colors = colors || readColors();
    if (meta) meta.setAttribute('content', bottom ? colors.bottom : colors.top);
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  // Ascolto dello scroll solo su smartphone/tablet: su desktop nessun lavoro
  let listening = false;
  const bind = () => {
    if (mq.matches && !listening) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      listening = true;
    } else if (!mq.matches && listening) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      listening = false;
    }
    update();
  };
  mq.addEventListener('change', bind);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();

